import { filter, propEq } from 'ramda'
import React from 'react'

import { useLinkTreeForm } from './_form/LinkTreeFormHandler'
import FlexGrid, { FlexCol } from '../../../components/structure/FlexGrid'
import LinkTreeItemPanel from './LinkTreeItemPanel'

const LinkTreeItems = () => {
  const { linkTreeItems } = useLinkTreeForm()

  return (
    <FlexGrid gutter={0.5} direction="column">
      {linkTreeItems.map((linkTreeItem, index) => (
        <FlexCol width="100%" key={linkTreeItem.number || linkTreeItem.id}>
          <LinkTreeItemPanel
            key={index}
            item={linkTreeItem}
            index={index}
            isLast={index + 1 === linkTreeItems.length}
            isTheOnlyOne={filter(propEq('enabled', true), linkTreeItems).length === 1}
          />
        </FlexCol>
      ))}
    </FlexGrid>
  )
}

export default LinkTreeItems
